<template>
    <div class="pt-3 pb-2 pl-2">
      <div class="quick-access-title">Quick Access</div>
      <v-row class="mt-1">
        <v-col
          v-for="item in items"
          :key="item.id"
          cols="6"
          class="d-flex justify-center pa-1"
        >
          <div class="qa-card" @click="$router.push({ name: item.to })">
            <div class="qa-icon-wrap">
              <svg v-if="item.id === 1" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 20V10"/><path d="M18 20V4"/><path d="M6 20v-6"/>
                <circle cx="12" cy="7" r="2" fill="currentColor" stroke="none" opacity="0.3"/>
                <circle cx="18" cy="2" r="1.5" fill="currentColor" stroke="none" opacity="0.3"/>
                <circle cx="6" cy="11" r="1.5" fill="currentColor" stroke="none" opacity="0.3"/>
              </svg>
              <svg v-else-if="item.id === 2" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
                <circle cx="8" cy="15" r="1.2" fill="currentColor" stroke="none" opacity="0.3"/>
                <circle cx="12" cy="15" r="1.2" fill="currentColor" stroke="none" opacity="0.3"/>
                <circle cx="16" cy="15" r="1.2" fill="currentColor" stroke="none" opacity="0.3"/>
                <circle cx="8" cy="19" r="1.2" fill="currentColor" stroke="none" opacity="0.3"/>
                <circle cx="12" cy="19" r="1.2" fill="currentColor" stroke="none" opacity="0.3"/>
              </svg>
            </div>
            <div class="qa-label">{{ item.name }}</div>
          </div>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        items: [
        { id: 1, name: "Performance & KPI", to: "selfserviceperformance", img: require('@/assets/performancekpilogo.png') },
        { id: 2, name: "Attendance", to: "selfserviceattendance" },
        ]
      };
    },
  
    methods: {

    },
  };
  </script>
  
  <style scoped>
  .quick-access-title {
    font-size: 0.7rem;
    font-weight: 700;
    color: #0D1B4B;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 6px;
    padding-left: 4px;
  }

  .qa-card {
    width: 80px;
    height: 80px;
    min-width: 80px;
    min-height: 80px;
    margin-left: 8px;
    background: #EEF2FF;
    border-radius: 14px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
    -webkit-transition: background 0.15s, -webkit-transform 0.1s;
    transition: background 0.15s, transform 0.1s;
    padding: 8px;
    gap: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    box-sizing: border-box;
  }

  .qa-card:hover {
    background: #C7D2FE;
    -webkit-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    transform: translateY(-2px);
  }

  .qa-icon-wrap {
    color: #4F6BFF;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-bottom: 4px;
  }

  .qa-label {
    font-size: 0.72rem;
    font-weight: 600;
    color: #3730A3;
    text-align: center;
    line-height: 1.3;
    min-height: 2.6em;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  </style>
  